module.exports = __webpack_public_path__ + "img/shannon-king-together-we-rise.e058821.jpg";